import { useTheme } from "@mui/system";

export default function MakeAppointmentIcon() {
  const theme = useTheme();
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M3.3335 6.66675H16.6668M3.3335 6.66675V14.0002C3.3335 14.9337 3.3335 15.4001 3.51515 15.7567C3.67494 16.0703 3.92972 16.3255 4.24333 16.4853C4.5995 16.6667 5.06599 16.6667 5.99759 16.6667H14.0027C14.9343 16.6667 15.4002 16.6667 15.7563 16.4853C16.0699 16.3255 16.3256 16.0703 16.4854 15.7567C16.6668 15.4005 16.6668 14.9347 16.6668 14.0031V6.66675M3.3335 6.66675V6.00024C3.3335 5.06682 3.3335 4.59976 3.51515 4.24325C3.67494 3.92964 3.92972 3.67486 4.24333 3.51507C4.59985 3.33341 5.0669 3.33341 6.00033 3.33341H6.66683M16.6668 6.66675V5.99751C16.6668 5.06591 16.6668 4.59942 16.4854 4.24325C16.3256 3.92964 16.0699 3.67486 15.7563 3.51507C15.3998 3.33341 14.9337 3.33341 14.0003 3.33341H13.3335M6.66683 3.33341H13.3335M6.66683 3.33341V1.66675M13.3335 3.33341V1.66675M12.5002 10.0001L9.16683 13.3334L7.50016 11.6667" 
        stroke={theme.palette.rgd.primary}
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  )
}